import React, { useState, ChangeEvent, DragEvent, useEffect, useRef } from 'react';
import { Icons } from "../../../icons/Icons";
import BuilderService from '../../../services/BuilderService';
import '../../../Components/Builder/builder-styling.css'
import { useUserDetails, useUpdateUserDetails } from '../../../../redux/hooks/UserDetails';
import { useTheme } from '../../../../redux/hooks/useTheme';

const validFileTypes=['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml'];
const MAX_FILE_SIZE=512*1024; // 512KB
interface BrandingProps {
    onClose: () => void;
}
interface BrandDetail {
    domain?: string;
    brandInfo: {
        logo: string;
        favicon: string;
        colors: string[];
    };
    customBrand: {
        logo: string;
        primaryColor: string;
        secondaryColor: string;
        backgroundColor: string;
    };
    enabled?: boolean;
}

export default function Branding({ onClose }: BrandingProps) {
    const builderService=new BuilderService();
    const {userDetail}=useUserDetails();
    const {updateUserDetail}=useUpdateUserDetails();
    const [step, setStep]=useState(1);
    //   const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [uploadLogo, setUploadLogo]=useState<string>('');
    const [errorMessage, setErrorMessage]=useState<string>('');
    const [brandingData, setBrandingData]=useState<BrandDetail>({
        domain: '',
        brandInfo: {
            logo: '',
            favicon: '',
            colors: []
        },
        customBrand: {
            logo: '',
            primaryColor: '',
            secondaryColor: '',
            backgroundColor: ''
        },
        enabled: false

    });
    const [selectedFile, setSelectedFile]=useState<File|null>(null);
    const [uploadMessage, setUploadMessage]=useState<string>('');
    const [disableFile, setDisableFile]=useState<boolean>(false);
    const [disableInput, setDisableInput]=useState<boolean>(false);
    const [selectedImage, setSelectedImage]=useState<string|null>(null);
    const [loader, setLoader]=useState<boolean>(false);
    const [isDragging, setIsDragging]=useState(false);

    const handleSetLogo=(logo: string) => {
        setBrandingData((prevBrandingData) => ({
            ...prevBrandingData,
            customBrand: { ...prevBrandingData.customBrand, logo: logo },
        }));
        setSelectedImage(logo);
    };
    const handleSetFavicon=(favicon: string) => {
        setBrandingData((prevBrandingData) => ({
            ...prevBrandingData,
            customBrand: { ...prevBrandingData.customBrand, logo: favicon },
        }));
        setSelectedImage(favicon);
    };

    const handleFileChange=(e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const file=e.target.files[0];
            handleUpload(file);
        }
    };

    const handleToggleChange=(event: React.ChangeEvent<HTMLInputElement>) => {
        setBrandingData({ ...brandingData, enabled: event.target.checked });
        const currentCustomBrand = { custombrand: brandingData.customBrand, enabled: event.target.checked };
        updateCustomBrand(currentCustomBrand);
    };
    const handleDragOver=(event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const handleDragEnter=(event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        console.log("Drag entered");
        setIsDragging(true);

    };

    const handleDragLeave=(event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        console.log("Drag left");
        setIsDragging(false);
    };

    const handleDrop=(event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const file=event.dataTransfer.files[0];
        console.log("File dropped:", file);
        setIsDragging(false);
        handleUpload(file);

    };

    const handleUpload=async (file: any) => {
        if (!file) {
            setUploadMessage('Please select or drop a image to upload.');
            return;
        }

        if (!validFileTypes.includes(file.type)) {
            setUploadMessage('Please upload an image in jpg, jpeg, png, or svg format.');
            return;
        }
        if (file.size > MAX_FILE_SIZE) {
            setUploadMessage('Please upload an image size less than 512KB.');
            return;
        }
        setSelectedFile(file);
        setDisableInput(true);
        const formData=new FormData();
        formData.append('image', file);
        if(file && formData.get('image')){
        try {
            setLoader(true);
            const response=await builderService.uploadFileAWS(formData);
            if (response  &&  response.data) {
                setUploadLogo(response.data);
                setUploadMessage(`${response.message}`);
            }
            setLoader(false);
        } catch (error) {
            setUploadMessage('File upload failed.Please try again..');
        }
      }
    };



    const { theme }=useTheme();
    const handleInputChange=(e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value }=e.target;

        if (name==='domain' && value.trim()==='') {
            setDisableFile(false);
        } else {
            setDisableFile(true);
        }

        setBrandingData({ ...brandingData, [name]: value });
    };

    const handleContinue=async () => {
        setErrorMessage('');
        if (step===1) {
            setStep(2);
        }
        if (step===2) {
            if (selectedFile && uploadLogo!=='' ) {
                try {
                    setLoader(true);
                    const response=await builderService.runBrandGuide(uploadLogo, 'file');
                    setLoader(false);
                    const { colors, logo, favicon }=response.data.brandDetails.brandInfo;
                    const newenabled =response.data.brandDetails.enabled;
                    setBrandingData((prevBrandingData) => ({
                        ...prevBrandingData,
                        brandInfo: {
                            ...prevBrandingData.brandInfo,
                            colors: colors,
                            logo: logo,
                            favicon: favicon,
                        },
                        enabled: newenabled
                    }));
                    updateUserDetail({...userDetail, brandDetails: {
                        ...userDetail.brandDetails,
                        brandInfo: {
                            ...userDetail.brandDetails.brandInfo,
                            logo: logo,
                            favicon: favicon,
                            colors: colors,
                        },
                        enabled: newenabled
                    },})
                    setStep(3);
                } catch (error) {
                    setStep(2);
                }
            } else if (brandingData.domain) {
                try {
                    setLoader(true);
                    const response=await builderService.runBrandGuide(brandingData.domain, "domain");
                    setLoader(false);
                    const { logo, favicon, colors }=response.data.brandDetails.brandInfo;
                    const newenabled =response.data.brandDetails.enabled;
                    setBrandingData((prevBrandingData) => ({
                        ...prevBrandingData,
                        brandInfo: {
                            ...prevBrandingData.brandInfo,
                            logo: logo,
                            favicon: favicon,
                            colors: colors,
                        },
                        enabled: newenabled
                    }));
                    updateUserDetail(
                        {...userDetail,
                            brandDetails: {
                                ...userDetail.brandDetails,
                                brandInfo: {
                                    ...userDetail.brandDetails.brandInfo,
                                    logo: logo,
                                    favicon: favicon,
                                    colors: colors,
                                },
                                enabled: newenabled
                            },
                        }
                    )
                    setStep(3);
                } catch (error) {
                    setStep(2);
                }
            } else {
                setStep(2);
                setUploadMessage('Please enter a domain or upload an image.');
            }
        }
        if (step===3) {
            if(brandingData.customBrand.logo) {
            setStep(4);
            } else {
                setErrorMessage('Please select a logo');
                setStep(3);
            }
        }
        if (step === 4) {
            const missingFields = [];
            if (!brandingData.customBrand.primaryColor) {
                missingFields.push('Primary Color');
            }
            if (!brandingData.customBrand.secondaryColor) {
                missingFields.push('Secondary Color');
            }
            if (!brandingData.customBrand.backgroundColor) {
                missingFields.push('Background Color');
            }
            if (missingFields.length > 0) {
                const errorMessage = `Please select ${missingFields.join(', ')}`;
                setErrorMessage(errorMessage);
                setStep(4);
            } else {
            const currentCustomBrand = { custombrand: brandingData.customBrand, enabled: brandingData.enabled };
              updateCustomBrand(currentCustomBrand);
                onClose();
            }
        }
        if (step===5) {
          
            onClose();
        }
    };

    const handleBack=() => {
        setErrorMessage('');
        if (step>1) {
            setStep(step-1);
        }
    };
    const clearData = ()=>{
        setBrandingData((prevBrandingData) => ({
                ...prevBrandingData,
                customBrand: {
                    ...prevBrandingData.customBrand,
                    logo: '',
                    primaryColor: '',
                    secondaryColor: '',
                    backgroundColor: ''
                }
            }));
    }
    const renderStep=() => {
        switch (step) {
            case 1:
                return (
                    <div className="space-y-6 mt-5" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',

                    }}>
                        <div className='flex flex-col gap-5'>
                           
                            <h2 className=" text-center" style={{ color: theme.brandingfinal, fontSize:'24px', fontWeight:'700', lineHeight:'30px' }}>Get Started <span className='gradient-text'> Branding</span></h2>
                            <p className="text-center" style={{color:theme.brandingHeading,fontSize:'18px', fontWeight:'600', lineHeight:'21px'  }}>Customize Your AI Tool with Your Brand Logo <br></br> and Colors</p>
                            <p className="text-center" style={{color:theme.subHeading,fontSize:'14px', fontWeight:'400'}}>This is a one-time setup, but you can change the <br></br> logo and colors anytime.</p>
                        </div>
                    </div>
                );
              
            case 2:
                return (
                    <>

                              
                                <div style={{
                                    width: '100%', pointerEvents: disableInput? 'none':'auto',
                                    opacity: disableInput? 0.5:1
                                }} className="relative flex flex-col justify-center items-center ">
                                    {/* <label style={{color:theme.pickerOne}} className='mb-[10px] ml-[16px] w-[100%]'>Domain/URL</label> */}
                                    <input
                                        type="text"
                                        name="domain"
                                        placeholder="Enter Your Domain/URL for Branding"
                                        className="w-[98%] border branding-placeholder  rounded-md px-4 py-2 text-gray-500 focus:outline-none "

                                        style={{borderColor: theme.brandingBorder, backgroundColor:theme.bradingInputbg}}
      
                                        onChange={handleInputChange}
                                    />
                                  
                                </div>

                                <div style={{color:theme.pickerOne}} className='mt-[20px] mb-[20px]'>or</div>

                        {loader? <img src="https://dlvkyia8i4zmz.cloudfront.net/r3tQgGlrTJmcKpUvZ5Kk_loader.svg" />:
                            <div className="space-y-6" style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                width:'100%'

                            }}>

                                {/* <div className="text-center font-medium" style={{ color: theme.color, fontSize: '16px' }}>OR</div> */}
                                <div className={`border-2 border-dashed rounded-lg p-[30px]  text-center ${isDragging? 'border-2 border-dashed border-red-300':''}`}
                                    style={{
                                        borderColor: theme.brandingBorder, height: '100', width:'100%', pointerEvents: disableFile? 'none':'auto',
                                        opacity: disableFile? 0.5:1,
                                        backgroundColor:theme. bradingdashbg
                                    }}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                    onDragEnter={handleDragEnter}
                                    onDragLeave={handleDragLeave}
                                    onClick={() => document.getElementById('fileInput')?.click()}
                                >
                                     <span className=" flex justify-center items-center mb-[11px] text-pink-700 cursor-pointer underline hover:text-pink-700"> 
                                        <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.7126 11.4155C23.9392 11.7794 25.6651 13.9514 25.6651 18.7064V18.859C25.6651 24.107 23.5635 26.2086 18.3155 26.2086H10.6724C5.42432 26.2086 3.32275 24.107 3.32275 18.859V18.7064C3.32275 13.9867 5.02514 11.8146 9.1813 11.4272" stroke="url(#paint0_linear_4021_360)" strokeWidth="1.65749" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M14.5 18.5773V5.21649" stroke="url(#paint1_linear_4021_360)" strokeWidth="1.65749" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M18.4331 7.83464L14.5 3.90155L10.5669 7.83464" stroke="url(#paint2_linear_4021_360)" strokeWidth="1.65749" strokeLinecap="round" strokeLinejoin="round"/>
                                        <defs>
                                        <linearGradient id="paint0_linear_4021_360" x1="4.68509" y1="26.2086" x2="24.5974" y2="12.1309" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#FB5F65"/>
                                        <stop offset="1" stopColor="#F377C5"/>
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_4021_360" x1="14.561" y1="18.5773" x2="15.896" y2="18.5305" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#FB5F65"/>
                                        <stop offset="1" stopColor="#F377C5"/>
                                        </linearGradient>
                                        <linearGradient id="paint2_linear_4021_360" x1="11.0465" y1="7.83464" x2="16.65" y2="2.58867" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#FB5F65"/>
                                        <stop offset="1" stopColor="#F377C5"/>
                                        </linearGradient>
                                        </defs>
                                        </svg>
                                     </span>
                                   
                                    <p style={{color:theme.brandingdrag}} className="text-[15px] leading-[20px] font-[500] text-[14px] leading-[20px] font-normal mb-2"
                                       
                                        // onDragOver={handleDragOver}
                                        // onDrop={handleDrop}
                                        // onDragEnter={handleDragEnter}
                                        // onDragLeave={handleDragLeave}
                                        // onClick={() => document.getElementById('fileInput')?.click()}
                                        >
                                        Drag brand logo here
                                    </p>
                                   <p style={{color:theme.brandingdragor}} className="text-[13px] leading-[20px] font-normaltext-[15px] leading-[20px] font-normal mb-2">
                                    or
                                    </p>
                                    <p className="text-[15px] leading-[20px] font-normaltext-[15px] leading-[20px] font-normal mb-1">
                                    <span className='gradient-text'>Browse</span>
                                    </p>
                                    <p style={{color:theme.brandingdragp}} className="text-[13px] leading-[19.8px] font-normaltext-[9px] leading-[20px] font-normal ">
                                    Max file size: <span style={{color:theme.brandingdragspan, fontWeight:500}}>512kb</span> 
                                    </p>
                                    <p style={{color:theme.brandingdragp}}  className="text-[13px] leading-[19.8px] font-normaltext-[9px] leading-[20px] font-normal">
                                    Support file type: <span style={{color:theme.brandingdragspan, fontWeight:500}}>jpg, png, pdf, svg</span> 
                                    </p>

                                    <input id="fileInput" type="file" style={{ display: 'none' }} onChange={handleFileChange} />
                                </div>
                                {uploadMessage && <p style={{ color: '#fd4b92' }}>{uploadMessage}</p>}
                            </div>
                        }

                      <div  className="flex flex-col gap-[15px] w-[48%] mt-[20px]">
                     
                      
                              
                      </div>
                     
                    </>
                );
            case 3:
                return (

                    <div className="space-y-6 flex flex-col items-center justify-center w-[98%]">
                        {/* <h2 className="text-2xl font-bold text-center" style={{ color: theme.color }}>Logo</h2> */}
                        <div className='flex justify-center item-center w-[84%]' >
                        <div className="flex justify-center space-x-4 w-full">
                            <div className="flex items-center justify-center w-[100%] gap-4 flex-wrap md:flex-nowrap" style={{ borderColor: theme.border }}>
                                <div className="w-[50%]">
                                    <div 
                                    style={{borderColor:theme.brandingBorder}}
                                        onClick={() => handleSetLogo(brandingData.brandInfo.logo)}
                                        className={`h-28 relative flex justify-center items-center border rounded-[4.51px] ${selectedImage===brandingData.brandInfo.logo || brandingData.customBrand.logo===brandingData.brandInfo.logo? 'border-1 border-gray-200' 
                                            : 'border-[1px] border-[${theme.brandingBorderLogo}]'}`}
                                    >
                                        <div className="flex justify-center items-center p-4 w-full h-full">
                                            {brandingData && brandingData.brandInfo && brandingData.brandInfo.logo? (
                                                <img
                                                    src={brandingData.brandInfo.logo}
                                                    alt="Uploaded logo"
                                                    className="max-w-full max-h-full min-h-[50px] object-contain"
                                                />
                                            ) : (
                                                <p className="text-sm" style={{ color: theme.color }}>No logo</p>
                                            )}
                                        </div>
                                        {((selectedImage===brandingData.brandInfo.logo || brandingData.customBrand.logo === brandingData.brandInfo.logo) &&  brandingData.brandInfo.logo!=='') && (
                                            <div className="absolute top-0 right-0 m-2">
                                                <Icons.Check className="w-6 h-6 text-green-500" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {brandingData.brandInfo.favicon && (  <div style={{color:theme.brandingfinal}}>or</div>)}
                                <div className="w-[50%]">
                                    {brandingData.brandInfo.favicon && (
                                        <div
                                        style={{borderColor:theme.brandingBorderLogo}}
                                            onClick={() => handleSetFavicon(brandingData.brandInfo.favicon)}
                                            className={` h-28 p-4 relative flex justify-center items-center border rounded-[4.51px] 
                                                ${selectedImage === brandingData.brandInfo.favicon || 
                                                brandingData.customBrand.logo === brandingData.brandInfo.favicon 
                                                  ? 'border-1 border-gray-200' 
                                                  : 'border-[1px] border-[${theme.brandingBorderLogo}]'}`}
                                            >
                                            <div className="w-full h-full flex justify-center items-center">
                                                {brandingData && brandingData.brandInfo && brandingData.brandInfo.favicon? (
                                                    <img
                                                        src={brandingData.brandInfo.favicon}
                                                        alt="Uploaded favicon"
                                                        className="max-w-full max-h-full min-h-[50px] object-contain"
                                                    />
                                                ):(
                                                    <p className="text-sm" style={{ color: theme.color }}>No Favicon</p>
                                                )}
                                            </div>
                                            {(selectedImage===brandingData.brandInfo.favicon || brandingData.customBrand.logo===brandingData.brandInfo.favicon) && (
                                                <div className="absolute top-0 right-0 m-2">
                                                    <Icons.Check className="w-6 h-6 text-green-500" />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                );
            case 4:
                return (
                    brandingData && brandingData.brandInfo && brandingData.brandInfo.colors.length>0 && 
                    <div className="space-y-6">
                        {/* <h2 className="text-2xl font-bold text-center" style={{ color: theme.pickerOne, fontWeight:500, lineHeight:'21.78px',fontSize:'18px' }}>Color</h2> */}
                        <div>
                            <p className="mb-[12px] text-[14px] font-[400] leading-[16.94px] text-center" style={{ color: theme.leadPopupSubHeading}}>Pick Your Primary Color</p>
                            <div className="flex items-center justify-center "  style={{ gap: "11px" }}>
  {brandingData &&
    brandingData.brandInfo &&
    brandingData.brandInfo.colors.map((color, index) => (
      <div className="w-[31px] h-[30px]" key={index}>
        <div
          className={`w-full h-full cursor-pointer relative ${
            brandingData.customBrand.primaryColor === color
              ? 'shadow-lg'
              : ''
          }`}
          style={{
            backgroundColor: color,
          }}
          onClick={() =>
            setBrandingData({
              ...brandingData,
              customBrand: {
                ...brandingData.customBrand,
                primaryColor: color,
              },
            })
          }
        >
              {brandingData.customBrand.primaryColor === color && (
            <Icons.Check className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-gray-800 dark:text-gray-200" />
          )}

        </div>
      </div>
    ))}
</div>

                        </div>
                        <div>
                            <p className="mb-[12px] text-[14px] font-normal leading-[16.94px] text-center" style={{ color: theme.leadPopupSubHeading }}>Pick Your Secondary Color</p>
                            <div className="flex justify-center flex-wrap " style={{ gap: "11px" }}>
  {brandingData &&
    brandingData.brandInfo &&
    brandingData.brandInfo.colors.map((color, index) => (
      <div className="w-[31px] h-[30px]" key={index}>
        <div
          className={`w-full h-full cursor-pointer  relative ${
            brandingData.customBrand.secondaryColor === color
              ? 'shadow-lg'
              : ''
          }`}
          style={{ backgroundColor: color }}
          onClick={() =>
            setBrandingData({
              ...brandingData,
              customBrand: {
                ...brandingData.customBrand,
                secondaryColor: color,
              },
            })
          }
        >
          {brandingData.customBrand.secondaryColor === color && (
            <Icons.Check className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-gray-800 dark:text-gray-200" />
          )}
        </div>
      </div>
    ))}
</div>
                        </div>
                        <div>
                            <p className="mb-[12px] text-[14px] font-normal leading-[16.94px] text-center" style={{ color: theme.leadPopupSubHeading }}>Pick Your Background Color</p>
                            <div className="flex flex-wrap justify-center" style={{ gap: "11px" }}>
  {brandingData &&
    brandingData.brandInfo &&
    brandingData.brandInfo.colors.map((color, index) => (
      <div className="w-[31px] h-[30px]" key={index}>
        <div
          className={`w-full h-full cursor-pointer  relative ${
            brandingData.customBrand.backgroundColor === color
              ? 'shadow-lg'
              : 'transparent'
          }`}
          style={{
            backgroundColor: color,
            // borderColor: theme.border || 'transparent',
          }}
          onClick={() =>
            setBrandingData({
              ...brandingData,
              customBrand: {
                ...brandingData.customBrand,
                backgroundColor: color,
              },
            })
          }
        >
          {brandingData.customBrand.backgroundColor === color && (
            <Icons.Check className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-gray-800 dark:text-gray-200" />
          )}
        </div>
      </div>
    ))}
</div>

                        </div>
                    </div>
                );
            case 5:
                return (
                    <div style={{backgroundColor: theme.primaryBackground}} className="w-full  mx-auto px-14 py-7 bg-white  rounded-lg ">
                        <div style={{ display:'flex', justifyContent:'center',alignItems:'center'}}>
                        <h2 className="text-[24px] font-[700] font-sora leading-[31.2px] text-center mb-6" style={{ color: theme.brandingfinal }}>You've successfully set up your<span className='gradient-text'> branding!</span> </h2>
                        </div>

                        {/* <div className="bg-pink-50 p-3 rounded-md flex items-center justify-between mb-6"> */}
                        <div style={{backgroundColor: theme.brandingTurnbg}} className="bg-red-50 p-1 pl-[10px] pr-[10px] rounded-md flex items-center justify-between mb-6 w-full ">
                            <span className="flex justify-center items-center">
                                <span style={{color: theme.leadPopupHeading}} className="text-[16px] font-[400] leading-[24px] text-gray-700">Enable Branding</span>
                                <span className="brandinghelptext cursor-pointer  p-[9px]" style={{ color: theme.brandingdrag }}>
                                <svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M7.98999 1.33179C4.3127 1.33179 1.33167 4.31282 1.33167 7.99011C1.33167 11.6674 4.3127 14.6484 7.98999 14.6484C11.6673 14.6484 14.6483 11.6674 14.6483 7.99011C14.6483 4.31282 11.6673 1.33179 7.98999 1.33179Z"
    stroke="currentColor"
    strokeWidth="1.33167"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M7.98999 10.6533V7.98999"
    stroke="currentColor"
    strokeWidth="1.33167"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M7.98999 5.32666H7.9825"
    stroke="currentColor"
    strokeWidth="1.33167"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

                                </span>
                            </span>

                            <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={brandingData.enabled}

                                    onChange={handleToggleChange}
                                />
                                <div style={{
                                    color: theme.buttonTextColor
                                }}
                                   className={`w-11 h-6 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[1.5px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${
                                    brandingData.enabled ? 'checkBox-gradient' : 'bg-gray-200'
                                  }`}
                                >

                                 </div>
                            </label>
                        </div>

                        <div  style={{display:'flex', justifyContent:'center', alignItems:'center', backgroundColor:theme.successfullyBrandingbg, borderRadius:'10px', padding:'25px'}} className="space-y-6 pt-4">
                            <div style={{alignItems:'center'}} className="flex  w-[60%]">
                                <div className="flex justify-center w-full md:w-[40%]">
                                    <div className="w-7/10 h-28  flex items-center justify-center">
                                    </div>
                                    <div style={{borderColor:theme.brandingBorder}} className="w-3/10 w-[100%] h-28 p-3 border-2 border-dashed border-gray-300 rounded-md  flex items-center justify-center ">
                                        {brandingData?.customBrand?.logo? (
                                            <img
                                                src={brandingData.customBrand.logo}
                                                alt="Uploaded logo"
                                                className="max-h-full max-w-full min-h-[60px] object-contain"
                                            />
                                        ):(
                                            <p className="text-sm text-gray-500" style={{ color: theme.color }}>No logo chosen</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div style={{alignItems:'self-start', marginTop:'0', gap:'10px'}} className="flex flex-col justify-evenly">
                                {brandingData?.customBrand?.primaryColor && (
                                    <div style={{display:'flex', flexDirection:'row-reverse', justifyContent:'center', alignItems:'center'}}>
                                        <h4 className="ml-[10px]" style={{ color: theme.brandingfinal, fontSize:'14px', fontWeight:400, lineHeight:'24px' }}>Primary Color</h4>
                                        <div style={{borderColor:theme.brandingBorder}} className="h-[38px] w-[38px] border border rounded-[4px] ">
                                            <div
                                                className="h-full w-full rounded-[4px]"
                                                style={{ backgroundColor: brandingData.customBrand.primaryColor }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {brandingData?.customBrand?.secondaryColor && (
                                    <div style={{display:'flex', flexDirection:'row-reverse', justifyContent:'center', alignItems:'center'}}>
                                        <h4 className="ml-[10px]" style={{  color: theme.brandingfinal, fontSize:'14px', fontWeight:400, lineHeight:'24px' }}>Secondary Color</h4>
                                        <div style={{borderColor:theme.brandingBorder }} className="h-[38px] w-[38px] border rounded-md">
                                            <div
                                                className="h-full w-full rounded-md"
                                                style={{ backgroundColor: brandingData.customBrand.secondaryColor}}
                                            />
                                        </div>
                                    </div>
                                )}
                                {brandingData?.customBrand?.backgroundColor && (
                                    <div style={{display:'flex', flexDirection:'row-reverse', justifyContent:'center', alignItems:'center'}}>
                                        <h4 className="ml-[10px]" style={{  color: theme.brandingfinal, fontSize:'14px', fontWeight:400, lineHeight:'24px' }}>Background Color</h4>
                                        <div style={{borderColor:theme.brandingBorder }}  className="h-[38px] w-[38px] border rounded-md">
                                            <div
                                                className="h-full w-full rounded-md"
                                                style={{ backgroundColor: brandingData.customBrand.backgroundColor}}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>


                    </div>
                )

            default:
                return null;
        }
    };
    const updateCustomBrand = async (brandDetail: any) => {
        console.log("brandDetail22:", brandDetail);
        try {
          const response = await builderService.updateBrandGuide(brandDetail);
            if(response && response.data){
                console.log("response1:", response);
              setBrandingData((prevBrandingData) => ({
                    ...prevBrandingData,
                    customBrand: {
                        ...prevBrandingData.customBrand,
                        logo: response.data.brandDetails.customBrand.logo,
                        primaryColor: response.data.brandDetails.customBrand.primaryColor,
                        secondaryColor: response.data.brandDetails.customBrand.secondaryColor,
                        backgroundColor: response.data.brandDetails.customBrand.backgroundColor
                    },
                    enabled: response.data.brandDetails.enabled
                }));
                updateUserDetail({
                    ...userDetail,
                    brandDetails: {
                        ...userDetail.brandDetails,
                        customBrand: {
                            ...userDetail.brandDetails.customBrand,
                            logo: response.data.brandDetails?.customBrand?.logo,
                            primaryColor: response.data.brandDetails?.customBrand?.primaryColor,
                            secondaryColor: response.data.brandDetails?.customBrand?.secondaryColor,
                            backgroundColor: response.data.brandDetails?.customBrand?.backgroundColor
                        },
                        enabled: response.data.brandDetails.enabled
                    }
                })
           }
        } catch (error) {
            console.log("error:", error);
        }
      };
    
    useEffect(() => {
        setBrandingData((prevBrandingData) => ({
            ...prevBrandingData,
            brandInfo: {
                ...prevBrandingData.brandInfo,
                logo: userDetail.brandDetails?.brandInfo?.logo,
                favicon: userDetail.brandDetails?.brandInfo?.favicon,
                colors: userDetail.brandDetails?.brandInfo?.colors,
            },
            customBrand: {
                ...prevBrandingData.customBrand,
                logo: userDetail.brandDetails?.customBrand?.logo,
                primaryColor: userDetail.brandDetails?.customBrand?.primaryColor,
                secondaryColor: userDetail.brandDetails?.customBrand?.secondaryColor,
                backgroundColor: userDetail.brandDetails?.customBrand?.backgroundColor
            },
            enabled: userDetail.brandDetails?.enabled
        }));
    }, []);

    useEffect(() => {
        if (userDetail && userDetail.brandDetails && userDetail.brandDetails.brandInfo && userDetail.brandDetails.brandInfo.logo) {
            setStep(3);
        }
        if (userDetail && userDetail.brandDetails &&  userDetail.brandDetails.customBrand && userDetail.brandDetails.customBrand.logo && userDetail.brandDetails.customBrand.primaryColor && userDetail.brandDetails.customBrand.secondaryColor && userDetail.brandDetails.customBrand.backgroundColor) {
            setStep(5);
        }
    }, []);


    useEffect(() => {
        setBrandingData((prevState: any) => {
            return {
                ...prevState,
                brandDetails: {
                    ...prevState.brandDetails,
                    customBrand: brandingData.customBrand,
                    enabled: brandingData.enabled
                }
            };
        });
    }, [brandingData.customBrand, brandingData.enabled]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 ">
                      
           <div className=''>
           <div  className="relative rounded-[14px] w-full rounded-[14px] p-[30px]" style={{maxWidth: step === 1 ? '864px' : '729px',background: theme.brandingBG,  filter: "blur(15%)", display:'flex', justifyContent:'space-between', alignItems:'center', gap: step === 5 ? '0' : '10px',   padding: step === 5 ? '0' : '30px'}}>
            <button
                       style={{top:'-16px', right:'-20px'}}
                          onClick={() => {onClose();clearData() }}
                          className="absolute text-gray-500 hover:text-gray-700"
                        >
                          <Icons.X
                            className="rounded-full p-1"
                            style={{
                              color: 'white',
                            }}
                          />
                        </button>
                      {step===1  && (
                        <div style={{width:'100%', paddingRight:'20px', maxWidth:'315px'}} className='popup-condition-one'>
                            <img src='https://dlvkyia8i4zmz.cloudfront.net/fYcCcFEQS4KqfzrhXQlx_brand.svg'/>
                        </div>
                       )}
               
               <div className='popup-condition-two'>
                        {step > 1 && step <= 4  && (
                          <div className="flex flex-col gap-4 items-start">
                            <label className="flex items-center">
                                <input type="radio" name="step" className="hidden" />
                                <span  className={`px-[24px] py-[12px] rounded-full font-[400] text-[14px] flex items-center justify-center`} 
                                style={{background: step === 2 ? 'linear-gradient(90.07deg, #FB5F65 0.09%, #F378C9 99.78%)': 'transparent', color: step ===2 ? 'white': theme.tabelLabelData}}
                                >
                                Step 01
                                {step === 2 && <span className="ml-2 text-white text-xs"></span>}
                                </span>
                            </label>

                            <label className="flex items-center">
                                <input type="radio" name="step" className="hidden" />
                                <span
                                className={`px-[24px] py-[12px] rounded-full font-[400] text-[14px] flex items-center justify-center`}
                                style={{background: step === 3 ? 'linear-gradient(90.07deg, #FB5F65 0.09%, #F378C9 99.78%)': 'transparent', color: step ===3 ? 'white': theme.tabelLabelData}}
                                >
                                Step 02
                                {step === 3 && <span className="ml-2 text-white text-xs"></span>}
                                </span>
                            </label>

                            <label className="flex items-center">
                                <input type="radio" name="step" className="hidden" />
                                <span className={`px-[24px] py-[12px] rounded-full font-[400] text-[14px] flex items-center justify-center`} 
                                 style={{background: step === 4 ? 'linear-gradient(90.07deg, #FB5F65 0.09%, #F378C9 99.78%)': 'transparent', color: step === 4 ? 'white': theme.tabelLabelData}}
                                >
                                Step 03
                                {step === 4 && <span className="ml-2 text-white text-xs"></span>}
                                </span>
                            </label>
                          </div>
                        )}
               </div>
                <div style={{backgroundColor: theme.brandingChildConatiner, borderRadius:'14px',minHeight: step === 1 ? '301px' : '409px',width: step === 5 ? '100%' : step === 1 ? '458px' : '506px', gap:'15px'}} className="p-[30px] flex flex-col justify-center items-center">
                    {renderStep()}

                    <div className=" flex flex-col items-center">
                        {/* {step>=2 && step<=4 && (!(userDetail.brandDetails?.brandInfo?.logo || userDetail.brandDetails?.brandInfo?.favicon)) && (
                            <div className="flex space-x-2 mb-4">
                                {[2, 3, 4].map((i) => (
                                    <div
                                        key={i}
                                        className={`w-2 h-2 rounded-full ${i===step? 'bg-[#FC5F66]':'bg-[#ECECEC]'}`}
                                        style={{ backgroundColor: i===step? undefined:theme.border }}
                                    />
                                ))}
                            </div>
                        )} */}
                      <div className="mb-3 text-[#fd4b92] text-sm pt-[10px]">{errorMessage}</div>                        
                        <div style={{alignItems:'center'}} className="flex justify-center space-x-4">
                            {(step>3 && step<5) && (
                              <button
                              className="px-[24px] py-[12px] mt-[20px] border branding-back hover:bg-gray-200 dark:hover:bg-gray-700 rounded-[10px] text-white transition-transform transform hover:scale-105"
                              style={{
                                backgroundColor: 'transparent', // Transparent background initially
                                color: theme.Darkone,   // Initial text color from the theme
                                borderRadius: '10px',
                                borderColor:theme.darkone,
                              }}
                              onClick={handleBack}
                            >
                              <span className='font-sora'>
                                Back
                              </span>
                            </button>
                            )}
                            {step===5 && (<button
                                className="px-[24px] py-[11px] mt-[20px] font-sora border branding-back rounded-[10px] text-white  hover:to-[#FB5F65] hover:text-white hover:shadow-lg transition-transform transform hover:scale-105"
                                style={{
                                    backgroundColor: 'transparent',
                                    color: theme.Darkone,
                                    border: '1px solid #FB5F65 ',
                                    borderColor:theme.darkone,
                                }}
                                onClick={() => setStep(3)}
                            >
                                Edit
                            </button>)}
                            <button
                              className="px-[24px] font-sora mt-[5px] branding-next-bg py-[12px] rounded-[8px] text-white hover:shadow-lg transition-transform transform hover:scale-105"

                                style={{
                                    backgroundColor:  'linear-gradient(90.07deg, #FB5F65 0.09%, #F378C9 99.78%)',
                                    color: theme.buttonTextColor, borderRadius: '12px',
                                    marginTop: step === 1 ? '0' : '20px',
                                }}
                                onClick={handleContinue}
                            >

                                {step===1? 'Configure Now':step===5? 'Finish':step===4? 'Finish':'Next'}
                            </button>

                        </div>

                    </div>

                </div>
            </div>
           </div>
        </div>
    );
}
